import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HistoryProductService {

  constructor(
    private http: HttpClient
  ) { }


  getNotificacionesEmpresaID(productoId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.notificaciones.getNotificacionesEmpresa+productoId);
  }


}
